import styled from 'styled-components';

export const SortDropdown = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 12px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 0;
    width: initial;
  }
`;
